<template>
  <div class="content">
    <div class="position">
      <p>行政前台</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">(1)负责行政相关制度的起草、制定、监督、执行。
(2)负责员工考勤建档与统计；月初（2个工作日内）统计员工考勤，事假、病假、迟到、早退及扣款金额。
(3)负责办公用品的采购及管理工作。
(4)负责各部门快递的统一管理和对快递公司的管理工作；合作快递的收发、跟踪查询、月底对账及申请付款审批；
(5)负责公司正常水、电的采购管理工作及房租、物业费等的申购工作。
(6)负责办公室设备的日常管理与维修管理。
(7)负责员工入职、离职手续等相关行政工作并协助人事开展面试等基础人事工作。
(8)负责公司卫生及安全的监督管理；卫生管理的监督与检查；及时核查公司存在或可能存在的安全隐患；
(9)负责员工外出的登记管理监督。
(10)负责接听、转达内外部联络电话。
(11)负责公司内外部接待、会议、培训、公司集体活动组织与安排，节假日慰问等。
(12)负责公司固定资产的管理。
(13)公司通讯录的建档与更新。
(14)负责网络公司事务的联系沟通。
(15)其他临时性工作安排。</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">(1)大专以上学历，女性，160cm以上，18-35岁之间，行政管理、商务助理、文秘等相关专业。
(2)形象气质佳、语言甜美、举止文雅、端庄大方。
(3)有较好的沟通表达能力及服务意识,具有一年及以上前台、行政工作经验者优先考虑。
(4)工作有条理、细致、认真、有责任心、办事严谨、对工作合理统筹。
(5)熟练电脑操作及Office办公软件,具备基本的网络知识。
(6)具备较强的文字撰写能力和应变能力。</p>
      </div>
    </div>


<div class="position">
      <p>行政总监</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">1、在公司经营战略指导下，全面计划、安排、管理市场部工作。
2、制定年度营销策略、营销计划及预算工作。
3、根据目标市场，竞争态势，客户需求等调查，及时掌握市场信息。
4、负责公司品牌推广及品牌运作，定期组织市场公关、广告宣传、促销等活动。
5、撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；
6、根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务。
7、分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；
8、对市场部工作进行指导、监督，协调部门与其他部门的合作关系。
9、项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算。
10、领导安排的其他事宜。</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">1、本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业。
2、5年以上相关工作经验，3年团队管理经验，熟悉互联网、电子商务市场动态。
3、熟知网络营销和线下资源紧密结合，五年以上企业管理经验。
4、有较强的执行力，能带领团队完成年度销售任务。
5、具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力
6、拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想；
7、擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意；
8、具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任。</p>
      </div>
    </div>
<div class="position">
      <p>行政总监</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">1、在公司经营战略指导下，全面计划、安排、管理市场部工作。
2、制定年度营销策略、营销计划及预算工作。
3、根据目标市场，竞争态势，客户需求等调查，及时掌握市场信息。
4、负责公司品牌推广及品牌运作，定期组织市场公关、广告宣传、促销等活动。
5、撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；
6、根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务。
7、分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；
8、对市场部工作进行指导、监督，协调部门与其他部门的合作关系。
9、项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算。
10、领导安排的其他事宜。</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">1、本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业。
2、5年以上相关工作经验，3年团队管理经验，熟悉互联网、电子商务市场动态。
3、熟知网络营销和线下资源紧密结合，五年以上企业管理经验。
4、有较强的执行力，能带领团队完成年度销售任务。
5、具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力
6、拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想；
7、擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意；
8、具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任。</p>
      </div>
    </div>
<div class="position">
      <p>行政总监</p>
    </div>
    <div class="statement">
      <p class="request">岗位职责：</p>
      <p class="desc">1、在公司经营战略指导下，全面计划、安排、管理市场部工作。
2、制定年度营销策略、营销计划及预算工作。
3、根据目标市场，竞争态势，客户需求等调查，及时掌握市场信息。
4、负责公司品牌推广及品牌运作，定期组织市场公关、广告宣传、促销等活动。
5、撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；
6、根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务。
7、分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；
8、对市场部工作进行指导、监督，协调部门与其他部门的合作关系。
9、项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算。
10、领导安排的其他事宜。</p>
    </div>
    <div class="statement second">
      <div>
        <p class="request">任职资格：</p>
        <p class="desc">1、本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业。
2、5年以上相关工作经验，3年团队管理经验，熟悉互联网、电子商务市场动态。
3、熟知网络营销和线下资源紧密结合，五年以上企业管理经验。
4、有较强的执行力，能带领团队完成年度销售任务。
5、具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力
6、拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想；
7、擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意；
8、具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任。</p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'homeJoinContent'
  }
</script>

<style scoped>

  div.content {
    margin: 2%;
    color: rgb(73, 73, 73);
  }

  div.position {
    font-family: PingFangSC-Semibold, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    text-align: left;
  }

  .statement {
    margin: 0;
    padding-bottom: 2%;
    padding-top: 2%;
  }

  p.request {
    font-size: 16px;
  }

  p.desc {
    font-size: 14px;
    line-height: 35px;
    padding-top: 2%;
  }

  p {
    text-align: left;
    white-space: pre-line;
    padding: 0;
    margin: 0;
  }

  .second {
    border-top: dashed;
    border-width: 2px;
    border-color: rgb(226,226,226);
  }

</style>



// WEBPACK FOOTER //
// HomeJoinAdministration.vue?b92e8fce